import React, { useEffect, useState, useCallback, useRef } from "react";
import ReactApexChart from "react-apexcharts";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import crossicon from "../assets/cross1.png";
import loader_video from "../assets/loaderaltra.gif";
import tableicon from "../assets/gotoTable.png"
import baricon from "../assets/bar-graph.png";
import lineicon from "../assets/minus.png";
import lineicon2 from "../assets/minus_red.png";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import { Space } from "antd";



import {
  ResponsiveContainer,
  ComposedChart,
  Line,
  Area,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend, Cell, ReferenceLine
} from 'recharts';
import { IoArrowBack } from "react-icons/io5";

const VisualisationPage = () => {
  const navigate = useNavigate();


  const [MainLoading, setMainLoading] = useState(true)


  const [country, setCountry] = useState("");
  const [event, setEvent] = useState("");
  const [impact, setimpact] = useState("");
  const [date, setdate] = useState("");
  const [time, settime] = useState("");


  const [frequency_date, setFrequency_date] = useState();
  const [Loading, setLoading] = useState(false);
  const [selectedTime, setSelectedTime] = useState(1);
  const [optionValue, setOptionValue] = useState("6");
  const [eventRange, setEventRange] = useState("6");


  const UKHeaders = [
    { name: "GBP/USD", id: "gbpusd" },
    { name: "GBP/JPY", id: "gbpjpy" },
    { name: "GBP/NZD", id: "gbpnzd" },
    { name: "EUR/GBP", id: "eurgbp" },
    { name: "GBP/CHF", id: "gbpchf" },
    { name: "GBP/AUD", id: "gbpaud" },
    { name: "GBP/CAD", id: "gbpcad" },
  ];
  const USHeaders = [
    { name: "GBP/USD", id: "gbpusd" },
    { name: "USD/JPY", id: "usdjpy" },
    { name: "NZD/USD", id: "nzdusd" },
    { name: "EUR/USD", id: "eurusd" },
    { name: "USD/CHF", id: "usdchf" },
    { name: "AUD/USD", id: "audusd" },
    { name: "USD/CAD", id: "usdcad" },
  ];
  const JPHeaders = [
    { name: "USD/JPY", id: "usdjpy" },
    { name: "GBP/JPY", id: "gbpjpy" },
    { name: "NZD/JPY", id: "nzdjpy" },
    { name: "EUR/JPY", id: "eurjpy" },
    { name: "CHF/JPY", id: "chfjpy" },
    { name: "AUD/JPY", id: "audjpy" },
    { name: "CAD/JPY", id: "cadjpy" },
  ];
  const CAHeaders = [
    { name: "USD/CAD", id: "usdcad" },
    { name: "CAD/JPY", id: "cadjpy" },
    { name: "NZD/CAD", id: "nzdcad" },
    { name: "EUR/CAD", id: "eurcad" },
    { name: "CAD/CHF", id: "cadchf" },
    { name: "AUD/CAD", id: "audcad" },
    { name: "GBP/CAD", id: "gbpcad" },
  ];
  const CHEHeaders = [
    { name: "USD/CHF", id: "usdchf" },
    { name: "CHF/JPY", id: "chfjpy" },
    { name: "NZD/CHF", id: "nzdchf" },
    { name: "EUR/CHF", id: "eurchf" },
    { name: "GBP/CHF", id: "gbpchf" },
    { name: "AUD/CHF", id: "audchf" },
    { name: "CAD/CHF", id: "cadchf" },
  ];
  const EUHeaders = [
    { name: "EUR/USD", id: "eurusd" },
    { name: "EUR/JPY", id: "eurjpy" },
    { name: "EUR/NZD", id: "eurnzd" },
    { name: "EUR/GBP", id: "eurgbp" },
    { name: "EUR/CHF", id: "eurchf" },
    { name: "EUR/AUD", id: "euraud" },
    { name: "EUR/CAD", id: "eurcad" },
  ];
  const AUHeaders = [
    { name: "AUD/USD", id: "audusd" },
    { name: "AUD/JPY", id: "audjpy" },
    { name: "AUD/NZD", id: "audnzd" },
    { name: "EUR/AUD", id: "euraud" },
    { name: "AUD/CHF", id: "audchf" },
    { name: "GBP/AUD", id: "gbpaud" },
    { name: "AUD/CAD", id: "audcad" },
  ];
  const NZHeaders = [
    { name: "NZD/USD", id: "nzdusd" },
    { name: "NZD/JPY", id: "nzdjpy" },
    { name: "GBP/NZD", id: "gbpnzd" },
    { name: "EUR/NZD", id: "eurnzd" },
    { name: "NZD/CHF", id: "nzdchf" },
    { name: "AUD/NZD", id: "audnzd" },
    { name: "NZD/CAD", id: "nzdcad" },
  ];

  const headers =
    country === "UK"
      ? UKHeaders
      : country === "US"
        ? USHeaders
        : country === "JP"
          ? JPHeaders
          : country === "CA"
            ? CAHeaders
            : country === "CH"
              ? CHEHeaders
              : country === "EU" ||
                country === "DE" ||
                country === "IT" ||
                country === "FR"
                ? EUHeaders
                : country === "AU"
                  ? AUHeaders
                  : NZHeaders;


  const handleOptionChange = (value) => {
    setEventRange(value);
    setOptionValue(value)
    // console.log("value", value)
  }


  const handlegoback = () => {
    navigate("/user/economicdata");
  };


  // <------third table averge movement varients are calculating here final table-------->



  // <----hi ashima here is the today 14-02-2024 new code starts------->


  // <---for testing now bro final is above ----->


  const [loading_forgraphs, setloading_forgraphs] = useState(true);

  const [loading_forgraphs_1stGraph_flat, setloading_forgraphs_1stGraph_flat] = useState(true);

  //  <-------3rd graph---->
  const [loading_forgraphs_3rdgraph, setloading_forgraphs_3rdgraph] = useState(true);
  const [
    loading_forgraphs_3rdgraph_flat0,
    setloading_forgraphs_3rdGraph_flat0,
  ] = useState(true);

  const [loading_forgraphs_4thgraph, setloading_forgraphs_4thgraph] = useState(true);
  const [loading_forgraphs_4thgraph_flat0, setloading_forgraphs_4thgraph_flat0] = useState(true);

  const [volatilityImpact_firsttable, setVolatilityImpact_firsttable] = useState("")
  const [volatilityImpact_firsttable_nonzero, setVolatilityImpact_firsttable_nonzero] = useState("")
  const [volatilityImpact_firsttable_zero, setVolatilityImpact_firsttable_zero] = useState("");




  // <----new code starts from here----->
  const [volatilityImpact_secondtable, setVolatilityImpact_secondtable] = useState("")

  const [volatilityImpact_secondtable_flatPOS_flatNEV, setVolatilityImpact_secondtable_flatPOS_flatNEV] = useState("")

  const getFirstTabledata = async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const eventName = decodeURIComponent(urlParams.get("eventName"));
      const eventcountry = decodeURIComponent(urlParams.get("eventcountry"));
      const eventdate = decodeURIComponent(urlParams.get("eventdate"));
      const eventtime = decodeURIComponent(urlParams.get("eventtime"));
      // const urlParams = new URLSearchParams(window.location.search);
      const eventId = decodeURIComponent(urlParams.get("eventId"));
      setLoading(true);
      setEvent(eventName);
      setCountry(eventcountry);
      setdate(eventdate);
      settime(eventtime)
      // console.log("hi event range before api" , eventRange)
      const response = await axios.get(`${process.env.REACT_APP_URL}/user/geteventtable/${eventId}`,
        {
          params: {
            eventRange: eventRange,
            eventType: "1min",

          },
        }
      )

      // console.log("hi event range after api" , eventRange)

      // const res_data = response.data.volatilityEvent.data;
      const res_data = response.data.volatilityEvent.data.output;
      const res_data_nonzero = response.data.volatilityEvent.data.nonZeroEvent;
      const res_data_zero = response.data.volatilityEvent.data.zeroEvent;
      const sorted_res_data = res_data.sort((a, b) => Object.keys(a)[0].localeCompare(Object.keys(b)[0]));
      const sorted_res_data_nonzero = res_data_nonzero.sort((a, b) => Object.keys(a)[0].localeCompare(Object.keys(b)[0]));
      const sorted_res_data_zero = res_data_zero.sort((a, b) => Object.keys(a)[0].localeCompare(Object.keys(b)[0]));
      // console.log("sorted_res_data---------main thing-->" , response.data);
      // console.log("sorted_res_data_zero" , sorted_res_data_zero);
      setVolatilityImpact_firsttable(sorted_res_data);
      setVolatilityImpact_firsttable_nonzero(sorted_res_data_nonzero);
      setVolatilityImpact_firsttable_zero(sorted_res_data_zero);

      // setLoading_3rdtable(true);

      // <----second table---->
      const second_table_res_data = response.data.event
        .data.output
      const second_table_res_data_nonzero = response.data.event
        .data.nonZeroEvent

      const second_table_res_data_zero = response.data.event
        .data.zeroEvent
      const second_table_res_data_flatPOS_flatNEV = response.data.event.data.postiveNegative

      // console.log("second_table_res_data" , second_table_res_data)
      // console.log("second_table_res_data_nonzero" , second_table_res_data_nonzero)
      // console.log("second_table_res_data_zero" , second_table_res_data_zero)
      // console.log("second_table_res_data_flatPOS_flatNEV" , second_table_res_data_flatPOS_flatNEV)

      setVolatilityImpact_secondtable(second_table_res_data)
      // setVolatilityImpact_secondtable_nonzero(second_table_res_data_nonzero)
      // setVolatilityImpact_secondtable_zero(second_table_res_data_zero)
      setVolatilityImpact_secondtable_flatPOS_flatNEV(second_table_res_data_flatPOS_flatNEV)
      setLoading(false);



    }
    catch (error) {
      // console.log("error" , error)
    }
  }

  useEffect(() => {
    getFirstTabledata();
  }, [])
  useEffect(() => {
    handleOptionChange();
    getFirstTabledata()

  }, [eventRange])


  const [state, setState] = useState({
    series: [],


    options: {
      chart: {
        height: 350,
        type: "line",
        // background: "#5a2989", // Solid dark background for better contrast
      },
      title: {
        text: ``,
        style: { color: "#686868", fontSize: "14px", fontWeight: "Bold" },
      },
      dataLabels: {
        enabled: false,
      },
      tooltip: {
        theme: "dark",
      },
      xaxis: {
        labels: {
          style: { colors: "#686868", fontSize: "14px", fontWeight: "Bold" },
        },
      },
      yaxis: [
        {
          title: {
            text: "Average Movement (%)",
            style: { color: "#686868", fontSize: "14px", fontWeight: "Bold" },
          },
          labels: {
            formatter: function (val) {
              return (
                (val % 1 === 0 ? val.toFixed(0) : parseFloat(val.toFixed(2))) +
                "%"
              );
            },
            style: { colors: "#686868", fontSize: "14px", fontWeight: "Bold" },
          },
        },
        {
          opposite: true,
          title: {
            text: "Average Movement (points)",
            style: { color: "#686868", fontSize: "14px", fontWeight: "Bold" },
          },
          labels: {
            formatter: function (val) {
              return val % 1 === 0
                ? val.toFixed(0)
                : parseFloat(val.toFixed(2));
            },
            style: { colors: "#686868", fontSize: "14px", fontWeight: "Bold" },
          },
        },
      ],
      stroke: { width: [0, 4] },
      labels: {
        formatter: (val) => (val % 1 === 0 ? val.toFixed(0) : parseFloat(val.toFixed(2))) + "%",
        style: { colors: "#686868" },
      },

      // REMOVE OPACITY FROM BARS
      plotOptions: {
        bar: {
          columnWidth: "24%",

          colors: {
            ranges: [
              {
                from: 0,
                to: 299,
                color: "#f57474",
              },
              {
                from: 300,
                to: 499,
                color: "#f7da05",
              },
              {
                from: 500,
                to: 10000,
                color: "#61f393",
              },
            ],
          },
        },

      },

      annotations: {
        // yaxis: [
        //   {
        //     y: 0,
        //     y2: 300,
        //     fillColor: "#f57474", // Brighter Red
        //     label: { show: false },
        //   },
        //   {
        //     y: 300,
        //     y2: 500,
        //     fillColor: "#f7da05", // Gold Yellow
        //     label: { show: false },
        //   },
        //   {
        //     y: 500,
        //     y2: 10000,
        //     fillColor: "#61f393", // Strong Green
        //     label: { show: false },
        //   },
        // ],
        yaxis: [],
      },

      legend: {
        show: false
      }
    },
  });

  const labelfuntion = () => {
    const final_Label_forGraph = Array.isArray(volatilityImpact_firsttable_nonzero)
      ? volatilityImpact_firsttable_nonzero.map(item => {
        let key = Object.keys(item).find(k => k.includes("1min"));
        return key ? key.replace("1min", "").toUpperCase().replace(/([A-Z]{3})([A-Z]{3})/, "$1/$2") : "";
      })
      : []

    if (final_Label_forGraph.length > 0) {
      setState(prevState => ({
        ...prevState,
        options: {
          ...prevState.options,
          xaxis: { ...prevState.options.xaxis, categories: final_Label_forGraph },
        },
      }));
      setState_1stGraph_flat(prevState => ({
        ...prevState,
        options: {
          ...prevState.options,
          xaxis: { ...prevState.options.xaxis, categories: final_Label_forGraph }, // ✅ Update labels
        },
      }));
      setState_3rdGraph(prevState => ({
        ...prevState,
        options: {
          ...prevState.options,
          xaxis: { ...prevState.options.xaxis, categories: final_Label_forGraph }, // ✅ Update labels
        },
      }));
      setState_3rdGraph_flat0(prevState => ({
        ...prevState,
        options: {
          ...prevState.options,
          xaxis: { ...prevState.options.xaxis, categories: final_Label_forGraph }, // ✅ Update labels
        },
      }));
    }
  }
  useEffect(() => {
    labelfuntion();
  }, [volatilityImpact_firsttable_nonzero]);

  const [state_1stGraph_flat, setState_1stGraph_flat] = useState({
    series: [],
    options: {
      chart: {
        height: 350,
        type: "line",
        // background: "#5a2989", // Solid dark background for better contrast
      },
      title: {
        text: ``,
        style: { color: "#686868", fontSize: "14px", fontWeight: "Bold" },
      },
      dataLabels: {
        enabled: false,
      },
      tooltip: {
        theme: "dark",
      },
      xaxis: {
        labels: {
          style: { colors: "#686868", fontSize: "14px", fontWeight: "Bold" },
        },
      },
      yaxis: [
        {
          title: {
            text: "Average Movement (%)",
            style: { color: "#686868", fontSize: "14px", fontWeight: "Bold" },
          },
          labels: {
            formatter: function (val) {
              return (
                (val % 1 === 0 ? val.toFixed(0) : parseFloat(val.toFixed(2))) +
                "%"
              );
            },
            style: { colors: "#686868", fontSize: "14px", fontWeight: "Bold" },
          },
        },
        {
          opposite: true,
          title: {
            text: "Average Movement (points)",
            style: { color: "#686868", fontSize: "14px", fontWeight: "Bold" },

          },
          labels: {
            formatter: (val) => (val % 1 === 0 ? val.toFixed(0) : parseFloat(val.toFixed(2))),
            style: { colors: "#686868", fontSize: "14px", fontWeight: "Bold" },
          },

        },
      ],
      stroke: { width: [0, 4] },

      // REMOVE OPACITY FROM BARS
      plotOptions: {
        bar: {
          columnWidth: "24%", // Adjust width if needed
          // borderRadius: 5, // Optional: rounded corners
          colors: {
            ranges: [
              {
                from: 0,
                to: 299,
                color: "#f57474", // Red
              },
              {
                from: 300,
                to: 499,
                color: "#f7da05", // Yellow
              },
              {
                from: 500,
                to: 10000,
                color: "#61f393", // Green
              },
            ],
          },
        },
      },

      annotations: {
        // yaxis: [
        //   {
        //     y: 0,
        //     y2: 300,
        //     fillColor: "#f57474", // Brighter Red
        //     label: { show: false },
        //   },
        //   {
        //     y: 300,
        //     y2: 500,
        //     fillColor: "#f7da05", // Gold Yellow
        //     label: { show: false },
        //   },
        //   {
        //     y: 500,
        //     y2: 10000,
        //     fillColor: "#61f393", // Strong Green
        //     label: { show: false },
        //   },
        // ],
        yaxis: [],
      },
      legend: {
        show: false
      }
    },
  });
  const [DataCount, setDataCount] = useState(0)
  const [dataCount_flat0, setDataCount_flat0] = useState(0)
  const [noDataAvailable, setNoDataAvailable] = useState(false);
  const [noDataAvailable_3rdgraph, setNoDataAvailable_3rdgraph] = useState(false);
  //  <---first graph ashima today---->

  useEffect(() => {
    if (volatilityImpact_firsttable_nonzero.length > 0) {
      setloading_forgraphs(false);
      setMainLoading(false);
      // const dataCount = volatilityImpact_firsttable.filter(item => item.finalMovement !== null && (item.finalMovement !== 0 || item.finalMovement !== 0.0));
      const dataCount = volatilityImpact_firsttable.filter(item => {
        const actualPrevValue = Number(item.actualminusprevious);
        return (
          item.actualminusprevious !== null &&
          item.actualminusprevious !== undefined &&
          item.actualminusprevious !== "" &&
          !isNaN(actualPrevValue) &&
          actualPrevValue !== 0
        );
      });
      //
      // console.log("dataCount" , dataCount , volatilityImpact_firsttable)
      const dataCountValue = dataCount.length
      // console.log("dataCountValue" , dataCountValue)
      setDataCount(dataCountValue)

      const filteredItems = volatilityImpact_firsttable_nonzero
        .sort((a, b) => {
          let keyA = Object.keys(a)[0].replace("1min", ""); // Remove "1min"
          let keyB = Object.keys(b)[0].replace("1min", "");
          return keyA.localeCompare(keyB);
        });
      // console.log("filteredItems" ,filteredItems)

      const valuesArray = filteredItems
        .map(item => {
          let key = Object.keys(item).find(k => k.includes("1min"));
          // console.log("key--->" , key)
          let value = key ? parseFloat(item[key].highminlowprevfive.replace("%", "")) : NaN;
          return isNaN(value) ? 0 : value;
        })
      // .filter(value => !isNaN(value));


      const filteredItems_linegraph = volatilityImpact_firsttable_nonzero
        .sort((a, b) => {
          let keyA = Object.keys(a)[0].replace("1min", "");
          let keyB = Object.keys(b)[0].replace("1min", "");
          return keyA.localeCompare(keyB);
        });

      const valuesArray_linegraph = filteredItems_linegraph.map(item => {
        let key = Object.keys(item).find(k => k.includes("1min"));
        let value = key ? parseFloat(item[key].highminlow.replace("%", "")) : NaN;
        return isNaN(value) ? 0 : value;
      })
      // .filter(value => !isNaN(value));


      // console.log("filteredItems:", filteredItems);



      setState((prevState) => {
        const updatedSeries = prevState.series.map((series) => {
          if (series.name === "Average Movement (%)") {
            return { ...series, data: [...valuesArray] };
          }
          if (series.name === "Average Movement (points)") {
            return { ...series, data: [...valuesArray_linegraph] }; // **Force new array to ensure re-render**
          }
          return series;
        });

        // If "Currency Correlation" or "Average Movement (%)" doesn't exist, add them
        if (!updatedSeries.find((series) => series.name === "Average Movement (%)")) {
          updatedSeries.push({
            name: "Average Movement (%)",
            type: "column",
            data: [...valuesArray],
          });
        }
        if (!updatedSeries.find((series) => series.name === "Average Movement (points)")) {
          updatedSeries.push({
            name: "Average Movement (points)",
            type: "line",
            data: [...valuesArray_linegraph],
          });
        }

        return { ...prevState, series: updatedSeries };
      });
    }
  }, [volatilityImpact_firsttable_nonzero]);

  // <----second graph flat(of first)---->
  // useEffect(() => {
  //   if (volatilityImpact_firsttable_zero.length > 0) {
  //     setloading_forgraphs_1stGraph_flat(false);
  //     setMainLoading(false);

  //     const filteredItems = volatilityImpact_firsttable_zero
  //     // .sort((a, b) => {
  //     //     let keyA = Object.keys(a)[0].replace("1min", ""); // Remove "1min"
  //     //     let keyB = Object.keys(b)[0].replace("1min", "");
  //     //     return keyA.localeCompare(keyB);
  //     // });
  //     .sort((a, b) => {
  //       let keyA = Object.keys(a)[0] || ""; 
  //       let keyB = Object.keys(b)[0] || ""; 
  //       return keyA.replace("1min", "").localeCompare(keyB.replace("1min", ""));
  //     });

  //     // const valuesArray = filteredItems.map(item => {
  //     //     let key = Object.keys(item).find(k => k.includes("1min"));
  //     //     return key ? parseFloat(item[key]?.highminlowprevfive.replace("%", "")) : null;
  //     // }).filter(value => !isNaN(value));

  //     const valuesArray = filteredItems.map(item => {
  //       let key = Object.keys(item).find(k => k.includes("1min"));
  //       return key && item[key]?.highminlowprevfive 
  //         ? parseFloat(item[key].highminlowprevfive.replace("%", "")) 
  //         : null;
  //     }).filter(value => value !== null && !isNaN(value));  // ✅ Ensure valid numbers only


  //     const filteredItems_linegraph = volatilityImpact_firsttable_zero
  //     .sort((a, b) => {
  //         let keyA = Object.keys(a)[0].replace("1min", ""); // Remove "1min"
  //         let keyB = Object.keys(b)[0].replace("1min", "");
  //         return keyA.localeCompare(keyB);
  //     });

  //     const valuesArray_linegraph = filteredItems_linegraph.map(item => {
  //         let key = Object.keys(item).find(k => k.includes("1min"));
  //         return key ? parseFloat(item[key].highminlow.replace("%", "")) : null;
  //     }).filter(value => !isNaN(value));

  //     setState_1stGraph_flat((prevState) => {
  //       const updatedSeries = prevState.series.map((series) => {
  //         if (series.name === "Currency Correlation") {
  //           return { ...series, data: [...valuesArray] };
  //         }
  //         if (series.name === "Average Movement (%)") {
  //           return { ...series, data: [...valuesArray_linegraph] }; // **Force new array to ensure re-render**
  //         }
  //         return series;
  //       });

  //       // If "Currency Correlation" or "Average Movement (%)" doesn't exist, add them
  //       if (!updatedSeries.find((series) => series.name === "Currency Correlation")) {
  //         updatedSeries.push({
  //           name: "Currency Correlation",
  //           type: "column",
  //           data: [...valuesArray],
  //         });
  //       }
  //       if (!updatedSeries.find((series) => series.name === "Average Movement (%)")) {
  //         updatedSeries.push({
  //           name: "Average Movement (%)",
  //           type: "line",
  //           data: [...valuesArray_linegraph],
  //         });
  //       }

  //       return { ...prevState, series: updatedSeries };
  //     });
  //   }
  // }, [volatilityImpact_firsttable_zero]);
  useEffect(() => {
    if (volatilityImpact_firsttable_zero.length > 0) {
      setloading_forgraphs_1stGraph_flat(false);
      setMainLoading(false);
      // console.log("volatilityImpact_firsttable_zero" , volatilityImpact_firsttable_zero)

      const dataCount = volatilityImpact_firsttable.filter(item => {
        const actualPrevValue = Number(item.actualminusprevious);
        return (
          item.actualminusprevious !== null &&
          item.actualminusprevious !== undefined &&
          item.actualminusprevious !== "" &&
          !isNaN(actualPrevValue) &&
          actualPrevValue === 0
        );
      });
      // console.log("dataCount" , dataCount)
      const dataCountValue = dataCount.length
      // console.log("dataCountValue---" , dataCountValue)
      setDataCount_flat0(dataCountValue)
      const filteredItems = volatilityImpact_firsttable_zero
        .filter(item => Object.keys(item).length > 0)
        .sort((a, b) => {
          let keyA = Object.keys(a)[0] || "";
          let keyB = Object.keys(b)[0] || "";
          return keyA.replace("1min", "").localeCompare(keyB.replace("1min", ""));
        });

      const valuesArray = filteredItems.map(item => {
        let key = Object.keys(item).find(k => k.includes("1min"));
        let value = key && item[key]?.highminlowprevfive
          ? parseFloat(item[key].highminlowprevfive.replace("%", ""))
          : NaN;
        return isNaN(value) ? 0 : value;
      })
      // .filter(value => value !== null && !isNaN(value));  

      const valuesArray_linegraph = filteredItems.map(item => {
        let key = Object.keys(item).find(k => k.includes("1min"));
        let value = key && item[key]?.highminlow
          ? parseFloat(item[key].highminlow.replace("%", ""))
          : NaN;
        return isNaN(value) ? 0 : value;
      })
      // .filter(value => value !== null && !isNaN(value));

      if (valuesArray.length === 0 || valuesArray.every(value => value === 0)) {
        setNoDataAvailable(true);
        // console.log("hi am here");
        return;
      } else {
        setNoDataAvailable(false);
        // console.log("hi am here in false");
      }
      setState_1stGraph_flat((prevState) => {
        const updatedSeries = prevState.series.map((series) => {
          if (series.name === "Average Movement (%)") {
            return { ...series, data: [...valuesArray] };
          }
          if (series.name === "Average Movement (points)") {
            return { ...series, data: [...valuesArray_linegraph] };
          }
          return series;
        });

        if (!updatedSeries.find((series) => series.name === "Average Movement (%)")) {
          updatedSeries.push({ name: "Average Movement (%)", type: "column", data: [...valuesArray] });
        }
        if (!updatedSeries.find((series) => series.name === "Average Movement (points)")) {
          updatedSeries.push({ name: "Average Movement (points)", type: "line", data: [...valuesArray_linegraph] });
        }

        return { ...prevState, series: updatedSeries };
      });
    }
  }, [volatilityImpact_firsttable_zero]);

  // <------second row graph means third graph----->
  // kapil=------------------------------


  // const [state_3rdGraph, setState_3rdGraph] = useState({
  //   series: [],
  //   options: {
  //     chart: { height: 350, type: "line" },
  //     stroke: { width: [0, 4] },
  //     title: { text: `` },
  //     dataLabels: { enabled: true, enabledOnSeries: [1] },
  //     labels: [
  //       "01 Jan 2001",
  //       "02 Jan 2001",
  //       "03 Jan 2001",
  //       "04 Jan 2001",
  //       "05 Jan 2001",
  //       "06 Jan 2001",
  //       "07 Jan 2001",
  //     ],
  //     yaxis: [
  //       { title: { text: "Currency Correlation" } },
  //       { opposite: true, title: { text: "Average Movement (%)" } },
  //     ],
  //   },
  // });

  // const [state_4thGraph, setState_4thGraph] = useState({
  //   series: [],
  //   options: {
  //     chart: {
  //       height: 350,
  //       type: "bar",
  //       stacked: true, // Enable stacking globally
  //     },
  //     title: {
  //       text: "Stacked Column Chart",
  //     },
  //     dataLabels: {
  //       enabled: true,
  //     },
  //     plotOptions: {
  //       bar: {
  //         horizontal: false, // Ensure vertical stacking
  //         columnWidth: "60%", // Adjust width if needed
  //         endingShape: "rounded",
  //         dataLabels: {
  //           total: {
  //             enabled: true,
  //             formatter: (val) => val.toFixed(2),
  //           },
  //         },
  //         stackType: "100%", // Enable stacking inside plotOptions
  //       },
  //     },
  //     yaxis: [
  //       {
  //         title: {
  //           text: "Stacked Values",
  //         },
  //       },
  //       {
  //         opposite: true,
  //         title: {
  //           text: "Percentage (%)",
  //         },
  //         // min: 0,
  //         // max: 100,
  //         // tickAmount: 5,
  //       },
  //     ],
  //     xaxis: {
  //       categories: ["1", "2", "3", "4", "5", "6", "7"], // Adjust categories as needed
  //     },
  //   },
  // });

  // <---working code till now ------->

  // const [state_4thGraph, setState_4thGraph] = useState({
  //   series: [],
  //   options: {
  //     chart: {
  //       height: 500, // Increase height for better visibility
  //       type: "bar",
  //       stacked: true, // Keep stacking enabled
  //       yAxisIndex: 0,
  //     },
  //     title: {
  //       text: "Stacked Column Chart",
  //     },
  //     dataLabels: {
  //       enabled: true,
  //     },
  //     plotOptions: {
  //       bar: {
  //         horizontal: false,
  //         columnWidth: "60%",
  //         endingShape: "rounded",
  //         dataLabels: {
  //           total: {
  //             enabled: true,
  //             formatter: (val) => val.toFixed(2),
  //           },
  //         },
  //       },
  //     },
  //     yaxis: [
  //       {
  //         title: { text: "Column Values (%)" },
  //         labels: {
  //           formatter: (val) => val.toFixed(2),
  //         },
  //         min: 0,
  //         max: undefined,
  //       },
  //       {
  //         opposite: true,
  //         title: { text: "Percentage (%)" },
  //         labels: {
  //           formatter: (val) => val.toFixed(2),
  //         },
  //       },
  //     ],
  //     xaxis: {
  //       categories: ["1", "2", "3", "4", "5", "6", "7"],
  //     },
  //   },
  // });


  const [state_3rdGraph, setState_3rdGraph] = useState({
    series: [
      { name: "Currency Correlation", type: "rangeBar", data: [] },
      { name: "Average Movement (%)", type: "line", data: [] },
    ],
    options: {
      // chart: { height: 350, type: "line"},
      stroke: { width: [0, 4] }, // Column: 0 width, Line: 4 width
      fill: {
        opacity: [1, 1], // full opacity for both series
      },

      title: { text: `of ${event || ""}`, style: { color: "#ffffff" } },
      dataLabels: { enabled: true, enabledOnSeries: [1] }, // Labels only for line graph
      tooltip: { theme: "dark" },
      xaxis: {
        labels: { style: { colors: "#686868" } }, // ✅ X-axis text white
      },
      yaxis: [
        {
          title: { text: "Currency Correlation", style: { color: "#686868" } }, // ✅ Title white
          labels: {
            style: { colors: "#686868" },
            formatter: (value) => `${value}%`,
          }, // ✅ Y-axis text white
        },
        {
          opposite: true,
          title: { text: "Average Movement (%)", style: { color: "#686868" } }, // ✅ Title white
          labels: { style: { colors: "#686868" } }, // ✅ Y-axis text white
        },
      ],
      labels: {
        formatter: (val) => (val % 1 === 0 ? val.toFixed(0) : parseFloat(val.toFixed(2))) + "%",
        style: { colors: "#686868" },
      },
      plotOptions: { bar: { distributed: true } }, // Enables different colors for bars
    },
  });
  const [state_3rdGraph_flat0, setState_3rdGraph_flat0] = useState({
    series: [
      { name: "Currency Correlation", type: "column", data: [] },
      { name: "Average Movement (%)", type: "line", data: [] },
    ],
    options: {
      chart: { height: 350, type: "line" },
      stroke: { width: [0, 4] }, // Column: 0 width, Line: 4 width
      title: { text: `of ${event || ""}`, style: { color: "#ffffff" } },
      dataLabels: { enabled: true, enabledOnSeries: [1] }, // Labels only for line graph
      tooltip: { theme: "dark" },
      xaxis: {
        labels: { style: { colors: "#686868" } }, // ✅ X-axis text white
      },
      yaxis: [
        {
          title: { text: "Currency Correlation", style: { color: "#686868" } }, // ✅ Title white
          labels: {
            style: { colors: "#686868" },
            formatter: (value) => `${value}%`,
          }, // ✅ Y-axis text white
        },
        {
          opposite: true,
          title: { text: "Average Movement (%)", style: { color: "#686868" } }, // ✅ Title white
          labels: { style: { colors: "#686868" } }, // ✅ Y-axis text white
        },
      ],
      labels: {
        formatter: (val) => (val % 1 === 0 ? val.toFixed(0) : parseFloat(val.toFixed(2))) + "%",
        style: { colors: "#686868" },
      },
      plotOptions: { bar: { distributed: true } }, // Enables different colors for bars
    },
  });

  // /,----it is also working but -100 , +100 issue coming---->
  const [chartData, setChartData] = useState([]);
  const [chartData_flat0, setChartData_flat0] = useState([]);

  // <--for third graph and 4th graph--->
  const [chartData3, setChartData3] = useState([]);
  const [chartData3_flat0, setChartData3_flat0] = useState([]);


  // <--third graph--->

  useEffect(() => {
    if (volatilityImpact_secondtable_flatPOS_flatNEV.length > 0) {
      setloading_forgraphs_3rdgraph(false);

      const filteredItems = volatilityImpact_secondtable_flatPOS_flatNEV
        .filter(item => Object.keys(item).length > 0)
        .sort((a, b) => {
          let keyA = Object.keys(a)[0] || "";
          let keyB = Object.keys(b)[0] || "";
          return keyA.replace("1min", "").localeCompare(keyB.replace("1min", ""));
        });

      const valuesArray_forarea1 = filteredItems.map(item => {
        let key = Object.keys(item).find(k => k.includes("1min"));
        let value = key ? parseFloat(item[key].closeminusopennonZeroPositive) : NaN;
        return isNaN(value) ? 0 : value;
      })
      const valuesArray2 = filteredItems.map(item => {
        let key = Object.keys(item).find(k => k.includes("1min"));
        let value = key ? parseFloat(item[key].closeminusopennonZeroNegative) : NaN;
        return isNaN(value) ? 0 : -Math.abs(value);;
      })

      const maxValuesArray = valuesArray_forarea1.map((val, index) => {
        const val2 = valuesArray2[index] ?? -Infinity;
        const maxValue = Math.max(val, val2);
      })
      const columndata = [valuesArray_forarea1, valuesArray2]

      // console.log("columndata" , columndata)

      // const columndata_forLables = volatilityImpact_secondtable_flatPOS_flatNEV.map(item => {
      //   // Get and sort keys that end with "1minprevfive"
      //   let keys = Object.keys(item)
      //     .filter(k => k.endsWith("1min"))
      //     .map(k => k.replace("1min", "").toUpperCase().replace(/([A-Z]{3})([A-Z]{3})/, "$1/$2")) // Format currency pair
      //     .sort((a, b) => a.localeCompare(b));

      //   // console.log("Formatted Keys:", keys); // Check output

      //   return keys;
      // });

      const allFormattedKeys = volatilityImpact_secondtable_flatPOS_flatNEV.flatMap(item =>
        Object.keys(item)
          .filter(k => k.endsWith("1min"))
          .map(k =>
            k.replace("1min", "").toUpperCase().replace(/([A-Z]{3})([A-Z]{3})/, "$1/$2")
          )
      );

      const uniqueSortedKeys = [...new Set(allFormattedKeys)].sort((a, b) => a.localeCompare(b));

      // console.log("columndata_forLables" , columndata_forLables)
      const values_forline = volatilityImpact_firsttable_nonzero
        .sort((a, b) => {
          let keyA = Object.keys(a)[0].replace("1min", "");
          let keyB = Object.keys(b)[0].replace("1min", "");
          return keyA.localeCompare(keyB);
        })
        .map(item => {
          let key = Object.keys(item).find(k => k.includes("1min"));
          let value = key ? parseFloat(item[key].highminlowprevfive.replace("%", "")) : NaN;
          return isNaN(value) ? 0 : value;
        })
      // const newData = valuesArray_forarea1.map((value, index) => ({

      //   name: columndata_forLables[index] || `Page ${String.fromCharCode(65 + index)}`, 
      //   Level0: columndata[0]?.[index] ?? null,
      //   Level1: columndata[1]?.[index] ?? null,

      //   fillColor,
      //   // Avg_Percentage_Movement: values_forline[index] || null
      //   Avg_Percentage_Movement: values_forline[index] 
      // }));
      const newData = valuesArray_forarea1.map((value, index) => {
        const level0 = columndata[0]?.[index] ?? 0;
        const level1 = columndata[1]?.[index] ?? 0;

        const maxAbs = Math.max(Math.abs(level0), Math.abs(level1));

        let fillColor = "#f57474"; // Red by default
        if (maxAbs > 80) fillColor = "#61f393";     // Green
        else if (maxAbs > 65 && maxAbs <= 80) fillColor = "#f7da05"; // Yellow

        return {
          name: uniqueSortedKeys[index] || `Page ${String.fromCharCode(65 + index)}`,
          Level0: level0,
          Level1: level1,
          fillColor,
          MovementAvgPercentage: values_forline[index]
        };
      });


      // console.log("newData ashima", newData);
      setChartData3(newData);
    }
  }, [volatilityImpact_firsttable_nonzero, volatilityImpact_secondtable_flatPOS_flatNEV]);


  // <----3rd graph new trial end---->
  // <----flat third graph --->


  useEffect(() => {
    if (volatilityImpact_secondtable_flatPOS_flatNEV.length > 0) {
      setloading_forgraphs_3rdGraph_flat0(false);

      const filteredItems = volatilityImpact_secondtable_flatPOS_flatNEV
        .filter(item => Object.keys(item).length > 0)
        .sort((a, b) => {
          let keyA = Object.keys(a)[0] || "";
          let keyB = Object.keys(b)[0] || "";
          return keyA.replace("1min", "").localeCompare(keyB.replace("1min", ""));
        });

      const valuesArray_forarea1 = filteredItems.map(item => {
        let key = Object.keys(item).find(k => k.includes("1min"));
        let value = key ? parseFloat(item[key].closeminusopennonFlatPostive) : NaN;
        return isNaN(value) ? 0 : value;
      })
      const valuesArray2 = filteredItems.map(item => {
        let key = Object.keys(item).find(k => k.includes("1min"));
        let value = key ? parseFloat(item[key].closeminusopennonFlatNegative) : NaN;
        return isNaN(value) ? 0 : -Math.abs(value);;
      })

      const maxValuesArray = valuesArray_forarea1.map((val, index) => {
        const val2 = valuesArray2[index] ?? -Infinity;
        const maxValue = Math.max(val, val2);
      })
      const columndata = [valuesArray_forarea1, valuesArray2]

      // console.log("columndata" , columndata)

      // const columndata_forLables = volatilityImpact_secondtable_flatPOS_flatNEV.map(item => {
      //   // Get and sort keys that end with "1minprevfive"
      //   let keys = Object.keys(item)
      //     .filter(k => k.endsWith("1min"))
      //     .map(k => k.replace("1min", "").toUpperCase().replace(/([A-Z]{3})([A-Z]{3})/, "$1/$2")) // Format currency pair
      //     .sort((a, b) => a.localeCompare(b));

      //   // console.log("Formatted Keys:", keys); // Check output

      //   return keys;
      // });
      const allFormattedKeys = volatilityImpact_secondtable_flatPOS_flatNEV.flatMap(item =>
        Object.keys(item)
          .filter(k => k.endsWith("1min"))
          .map(k =>
            k.replace("1min", "").toUpperCase().replace(/([A-Z]{3})([A-Z]{3})/, "$1/$2")
          )
      );

      const uniqueSortedKeys = [...new Set(allFormattedKeys)].sort((a, b) => a.localeCompare(b));


      const values_forline = volatilityImpact_firsttable_zero
        .sort((a, b) => {
          let keyA = Object.keys(a)[0].replace("1min", "");
          let keyB = Object.keys(b)[0].replace("1min", "");
          return keyA.localeCompare(keyB);
        })
        .map(item => {
          let key = Object.keys(item).find(k => k.includes("1min"));
          let value = key ? parseFloat(item[key].highminlowprevfive.replace("%", "")) : NaN;
          return isNaN(value) ? 0 : value;
        })
      const newData = valuesArray_forarea1.map((value, index) => {
        const level0 = columndata[0]?.[index] ?? 0;
        const level1 = columndata[1]?.[index] ?? 0;

        const maxAbs = Math.max(Math.abs(level0), Math.abs(level1));

        let fillColor = "#f57474"; // Red by default
        if (maxAbs > 80) fillColor = "#61f393";     // Green
        else if (maxAbs > 65 && maxAbs <= 80) fillColor = "#f7da05"; // Yellow

        return {
          name: uniqueSortedKeys[index] || `Page ${String.fromCharCode(65 + index)}`,
          Level0: level0,
          Level1: level1,
          fillColor,
          MovementAvgPercentage: values_forline[index]
        };
      });

      setChartData3_flat0(newData);
    }
  }, [volatilityImpact_firsttable_nonzero, volatilityImpact_secondtable_flatPOS_flatNEV]);












  let columnDates;
  // <--forth graph--->
  useEffect(() => {
    if (volatilityImpact_firsttable_nonzero.length > 0) {
      setloading_forgraphs_4thgraph(false);
      const lineData = [89, 76, 65, 200, 588, 322, 700];

      let valuesArray_forarea1 = volatilityImpact_firsttable_nonzero
        .sort((a, b) => {
          let keyA = Object.keys(a)[0].replace("1min", "");
          let keyB = Object.keys(b)[0].replace("1min", "");
          return keyA.localeCompare(keyB);
        })
        .map(item => {
          let key = Object.keys(item).find(k => k.includes("1min"));
          let value = key ? parseFloat(item[key].highminlowprevfive.replace("%", "")) : NaN;
          return isNaN(value) ? 0 : value;
        })
      // .filter(value => !isNaN(value));


      columnDates = volatilityImpact_firsttable
        .filter(item => {
          const actualPrevValue = Number(item.actualminusprevious);
          return (
            item.actualminusprevious !== null &&
            item.actualminusprevious !== undefined &&
            item.actualminusprevious !== "" &&
            !isNaN(actualPrevValue) &&
            actualPrevValue !== 0
          );
        })
        .map(item => {
          return item?.date;
        });

      // console.log("columnDates" ,columnDates)

      console.log("volatilityImpact_firsttable", volatilityImpact_firsttable)
      const columndata = volatilityImpact_firsttable
        .filter(item => {
          const actualPrevValue = Number(item.actualminusprevious);
          return (
            item.actualminusprevious !== null &&
            item.actualminusprevious !== undefined &&
            item.actualminusprevious !== "" &&
            !isNaN(actualPrevValue) &&
            actualPrevValue !== 0
          );
        })
        .map(item => {
          // Get and sort keys that end with "1minprevfive"
          let keys = Object.keys(item)
            .filter(k => k.endsWith("1minprevfive"))
            .sort((a, b) => a.localeCompare(b));

          // console.log("Sorted Keys:", keys);

          // Extract values based on sorted keys
          return keys
            .map(key => {
              let highlowValue = item[key]?.[0]?.highlow;
              let value = highlowValue ? parseFloat(highlowValue.replace("%", "")) : NaN;
              return isNaN(value) ? 0 : value;
            })
          // .filter(value => value !== null); 
        });
      console.log("4th graph column data", columndata)



      const columndata_forLables = volatilityImpact_firsttable.map(item => {
        // Get and sort keys that end with "1minprevfive"
        let keys = Object.keys(item)
          .filter(k => k.endsWith("1minprevfive"))
          .map(k => k.replace("1minprevfive", "").toUpperCase().replace(/([A-Z]{3})([A-Z]{3})/, "$1/$2")) // Format currency pair
          .sort((a, b) => a.localeCompare(b));

        // console.log("Formatted Keys:", keys); // Check output

        return keys;
      });


      // console.log("valuesArray_forarea1", valuesArray_forarea1);

      // const newData = valuesArray_forarea1.map((value, index) => ({
      //   // name: `Page ${String.fromCharCode(65 + index)}`,
      //   name: columndata_forLables[index] || `Page ${String.fromCharCode(65 + index)}`, 
      //   Level0: columndata[0]?.[index] ?? null,
      //   Level1: columndata[1]?.[index] ?? null,
      //   Level2: columndata[2]?.[index] ?? null,
      //   Level3: columndata[3]?.[index] ?? null,
      //   Level4: columndata[4]?.[index] ?? null,
      //   Level5: columndata[5]?.[index] ?? null,
      //   Level6: columndata[6]?.[index] ?? null,
      //   MovementAvgPercentage: value,
      //   // variance: lineData[index] 
      // }));
      const newData = valuesArray_forarea1.map((value, index) => {
        const rowData = {
          name: columndata_forLables[index] || `Page ${String.fromCharCode(65 + index)}`,
          MovementAvgPercentage: value,
        };

        columnDates.forEach((date, colIndex) => {
          rowData[date] = columndata[colIndex]?.[index] ?? null;
        });

        return rowData;
      });


      console.log("newData", newData);
      setChartData(newData);
    }
  }, [volatilityImpact_firsttable_nonzero, volatilityImpact_firsttable]);

  let someColorPalette = [
    "#008ffbd9", "#00e396c4", "#feb019d1",
    "#ff4560d6", "#775dd0d1", "#e1569a", "#e377c2"
  ];

  let columnDates2;
  // <------forth graph flat values -0---->
  useEffect(() => {
    if (volatilityImpact_firsttable_nonzero.length > 0) {
      setloading_forgraphs_4thgraph_flat0(false);
      const lineData = [89, 76, 65, 200, 588, 322, 700];

      let valuesArray_forarea1 = volatilityImpact_firsttable_zero
        .sort((a, b) => {
          let keyA = Object.keys(a)[0].replace("1min", "");
          let keyB = Object.keys(b)[0].replace("1min", "");
          return keyA.localeCompare(keyB);
        })
        .map(item => {
          let key = Object.keys(item).find(k => k.includes("1min"));
          let value = key ? parseFloat(item[key].highminlowprevfive.replace("%", "")) : NaN;
          return isNaN(value) ? 0 : value;
        })
      // .filter(value => !isNaN(value));

      columnDates2 = volatilityImpact_firsttable
        .filter(item => {
          const actualPrevValue = Number(item.actualminusprevious);
          return (
            item.actualminusprevious !== null &&
            item.actualminusprevious !== undefined &&
            item.actualminusprevious !== "" &&
            !isNaN(actualPrevValue) &&
            actualPrevValue === 0
          );
        })
        .map(item => {
          return item?.date;
        });

      const columndata = volatilityImpact_firsttable
        .filter(item => {
          const actualPrevValue = Number(item.actualminusprevious);
          return (
            item.actualminusprevious !== null &&
            item.actualminusprevious !== undefined &&
            item.actualminusprevious !== "" &&
            !isNaN(actualPrevValue) &&
            actualPrevValue === 0
          );
        })
        .map(item => {
          // Get and sort keys that end with "1minprevfive"
          let keys = Object.keys(item)
            .filter(k => k.endsWith("1minprevfive"))
            .sort((a, b) => a.localeCompare(b));

          // console.log("Sorted Keys:", keys);

          // Extract values based on sorted keys
          return keys
            .map(key => {
              let highlowValue = item[key]?.[0]?.highlow;
              let value = highlowValue ? parseFloat(highlowValue.replace("%", "")) : NaN;
              return isNaN(value) ? 0 : value;
            })
          // .filter(value => value !== null); // Remove null values
        });

      // console.log("item" , columndata)

      const columndata_forLables = volatilityImpact_firsttable.map(item => {
        // Get and sort keys that end with "1minprevfive"
        let keys = Object.keys(item)
          .filter(k => k.endsWith("1minprevfive"))
          .map(k => k.replace("1minprevfive", "").toUpperCase().replace(/([A-Z]{3})([A-Z]{3})/, "$1/$2")) // Format currency pair
          .sort((a, b) => a.localeCompare(b));

        // console.log("Formatted Keys:", keys); // Check output

        return keys;
      });


      // console.log("valuesArray_forarea1", valuesArray_forarea1);

      // const newData = valuesArray_forarea1.map((value, index) => ({
      //   // name: `Page ${String.fromCharCode(65 + index)}`,
      //   name: columndata_forLables[index] || `Page ${String.fromCharCode(65 + index)}`, 
      //   Level0: columndata[0]?.[index] ?? null,
      //   Level1: columndata[1]?.[index] ?? null,
      //   Level2: columndata[2]?.[index] ?? null,
      //   Level3: columndata[3]?.[index] ?? null,
      //   Level4: columndata[4]?.[index] ?? null,
      //   Level5: columndata[5]?.[index] ?? null,
      //   Level6: columndata[6]?.[index] ?? null,
      //   MovementAvgPercentage: value,
      //   // variance: lineData[index] 
      // }));
      const newData = valuesArray_forarea1.map((value, index) => {
        const rowData = {
          name: columndata_forLables[index] || `Page ${String.fromCharCode(65 + index)}`,
          MovementAvgPercentage: value,
        };

        columnDates2.forEach((date, colIndex) => {
          rowData[date] = columndata[colIndex]?.[index] ?? null;
        });

        return rowData;
      });


      // console.log("newData", newData);
      setChartData_flat0(newData);
    }
  }, [volatilityImpact_firsttable_zero, volatilityImpact_firsttable]);


  useEffect(() => {
    document.body.style.backgroundColor = "#d2c2f070";
    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);


  const handleGenerateTables = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const eventimpact = decodeURIComponent(urlParams.get("eventimpact"));
    const eventtime = decodeURIComponent(urlParams.get("eventtime"));
    const eventdate = decodeURIComponent(urlParams.get("eventdate"));
    const eventId = decodeURIComponent(urlParams.get("eventId"));
    const url = new URL(window.location.origin + "/user/eventshistory");
    url.searchParams.set("eventName", event);
    url.searchParams.set("eventcountry", country);
    url.searchParams.set("eventimpact", eventimpact);
    url.searchParams.set("eventtime", eventtime);
    url.searchParams.set("eventdate", eventdate);
    url.searchParams.set("eventId", eventId);

    const newTab = window.open(url.toString(), "_blank");
  };

  return (
    <>
      <div className="min-h-screen pb-10 font-sans text-[#334155] bg-[#F8FAFC]">
        {/* Header Card */}
        <div className="w-full max-w-[96%] mx-auto mt-6 bg-white rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.04)] border border-[#E2E8F0] overflow-hidden">
          <div className="h-1.5 w-full bg-gradient-to-r from-[#818CF8] via-[#A78BFA] to-[#F472B6]" />
          <div className="p-6 md:p-8 flex flex-col md:flex-row md:items-center justify-between gap-6">
            <div>
              <div className="flex items-center gap-2 mb-2">
                <span className="bg-[#EEF2FF] text-[#6366F1] px-2.5 py-0.5 rounded-full text-xs font-bold uppercase tracking-wide border border-[#E0E7FF]">
                  Event Analysis
                </span>
                <span className="text-[#94A3B8] text-xs font-semibold uppercase tracking-wider">
                  {country}
                </span>
              </div>
              <h1 className="text-2xl md:text-3xl font-bold text-[#1E293B] tracking-tight">
                {event}
              </h1>
            </div>

            <div className="flex flex-wrap gap-4">
              <div className="bg-[#F8FAFC] px-4 py-2 rounded-xl border border-[#E2E8F0] flex flex-col">
                <span className="text-[10px] uppercase font-bold text-[#94A3B8] tracking-wider">Date</span>
                <span className="text-sm font-bold text-[#334155]">{date}</span>
              </div>
              <div className="bg-[#F8FAFC] px-4 py-2 rounded-xl border border-[#E2E8F0] flex flex-col">
                <span className="text-[10px] uppercase font-bold text-[#94A3B8] tracking-wider">Time (GMT)</span>
                <span className="text-sm font-bold text-[#334155]">{time}</span>
              </div>
            </div>
          </div>
        </div>
        {
          MainLoading ?
            <>
              <div className="">
                <div className="font-semibold m-6 font-xl text-center flex justify-center items-center">
                  Wait for charts .....
                </div>

                <div className="loader-container w-full flex justify-center ">

                  <img
                    src={loader_video}
                    title="loader"
                    alt="loader"
                    className="w-[300px] h-[300px]"
                    // width={500}
                    // height={600}
                    autoPlay
                    loop
                    muted
                  />

                </div>
                {/* </div> */}

              </div>
            </> :
            <>
              <div className="w-full max-w-[96%] mx-auto mt-6 mb-8 flex flex-col md:flex-row justify-between items-center gap-4 bg-white p-4 rounded-2xl shadow-sm border border-[#E2E8F0]">
                <div className="flex items-center gap-4 w-full md:w-auto">
                  <button
                    onClick={() => navigate("/user/economicdata")}
                    className="p-3 rounded-xl bg-[#F1F5F9] text-[#64748B] hover:bg-[#E2E8F0] hover:text-[#334155] transition-all duration-200 group"
                    title="Back"
                  >
                    <IoArrowBack className="text-xl group-hover:-translate-x-0.5 transition-transform" />
                  </button>

                  {/* <--show underline data button---> */}
                  <div className="flex flex-col">
                    <span className="text-[10px] uppercase font-bold text-[#94A3B8] tracking-wider mb-1 ml-1">Range</span>
                    <Space
                      style={{
                        width: "100%",
                        paddingTop: 0,
                        height: "46px",
                      }}
                      direction="vertical"
                    >
                      <FormControl size="small" sx={{ minWidth: 140 }}>
                        {/* <InputLabel id="range-select-label">
                Select Range
              </InputLabel> */}
                        <Select
                          labelId="range-select-label"
                          //  label="Events Range"
                          value={eventRange}
                          defaultValue="6"
                          onChange={(e) => handleOptionChange(e.target.value)}
                          displayEmpty
                          sx={{
                            borderRadius: "12px",
                            backgroundColor: "#F8FAFC",
                            "& .MuiOutlinedInput-notchedOutline": { border: "1px solid #E2E8F0" },
                            "&:hover .MuiOutlinedInput-notchedOutline": { border: "1px solid #CBD5E1" },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "2px solid #818CF8" },
                            height: "40px",
                            fontSize: "14px",
                            fontWeight: 600,
                            color: "#334155",
                            boxShadow: "none"
                          }}
                        >
                          <MenuItem value="6">Last 6</MenuItem>
                          <MenuItem value="12">Last 12</MenuItem>
                          <MenuItem value="24">Last 24</MenuItem>
                        </Select>
                      </FormControl>
                    </Space>
                  </div>
                </div>

                {/* Show Underlying Data Button */}
                <button
                  onClick={handleGenerateTables}
                  className="
                    flex items-center gap-2 px-5 py-2.5 rounded-xl
                    bg-[#EEF2FF] border border-[#E0E7FF]
                    text-[#4F46E5] font-bold text-sm
                    hover:bg-[#E0E7FF] hover:border-[#C7D2FE] hover:shadow-md
                    transition-all duration-200
                    w-full md:w-auto justify-center
                  "
                >
                  <img
                    src={tableicon}
                    alt="table"
                    className="w-5 h-5 opacity-90"
                  />
                  <span>Show Underlying Data</span>
                </button>
              </div>

              <div className="max-w-[96%] mx-auto grid grid-cols-1 xl:grid-cols-2 gap-8 mb-10">
                {/* Column 1: Non-Zero Event */}
                <div className="flex flex-col gap-6">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="h-8 w-1 bg-[#6366F1] rounded-full"></div>
                    <h1 className="text-xl font-bold text-[#1E293B] tracking-tight">Non- Zero event</h1>
                  </div>

                  {/* Chart 1: Market Impact Analysis */}
                  <div id="chart" className="w-full">
                    {loading_forgraphs ? (
                      <div className="h-[400px] flex items-center justify-center bg-white rounded-2xl border border-[#E2E8F0]">
                        <div className="flex flex-col items-center gap-2">
                          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#6366F1]"></div>
                          <p className="text-[#64748B] font-medium text-sm">Loading Chart...</p>
                        </div>
                      </div>
                    ) : (
                      <div className="bg-white p-6 rounded-2xl shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] border border-[#E2E8F0]">
                        <div className="flex justify-between items-center mb-6">
                          <h3 className="text-[#334155] font-bold text-lg">Market Impact Analysis</h3>
                          <div className="px-3 py-1 bg-[#F1F5F9] rounded-lg border border-[#E2E8F0]">
                            <p className="text-xs font-bold text-[#64748B]">Data Count: <span className="text-[#334155]">{DataCount}</span></p>
                          </div>

                        </div>
                        <ReactApexChart
                          options={state.options}
                          series={state.series}
                          type="line"
                          height={350}
                        />

                        {/* Legend 1 */}
                        <div className="mt-6 p-4 bg-[#F8FAFC] rounded-xl border border-[#F1F5F9]">
                          <div className="flex flex-wrap gap-y-3 gap-x-6 justify-center items-center text-sm text-[#475569]">
                            <div className="flex items-center gap-2 min-w-[200px]">
                              <img src={baricon} alt="bars" className="w-4 h-4 opacity-70" />
                              <span className="font-bold">Average Movement (%):</span>
                            </div>
                            <div className="flex items-center gap-2"><span className="w-3 h-3 rounded-full bg-[#f57474]"></span>0–299</div>
                            <div className="flex items-center gap-2"><span className="w-3 h-3 rounded-full bg-[#f7da05]"></span>300–499</div>
                            <div className="flex items-center gap-2"><span className="w-3 h-3 rounded-full bg-[#61f393]"></span> 500+</div>
                          </div>
                          <div className="flex flex-wrap gap-y-3 gap-x-6 justify-center items-center text-sm text-[#475569] mt-3 pt-3 border-t border-[#E2E8F0]">
                            <div className="flex items-center gap-2 min-w-[200px]">
                              <img src={lineicon} alt="line" className="w-4 h-4 opacity-70" />
                              <span className="font-bold">Average Movement (points):</span>
                            </div>
                            <div className="opacity-0"><span className="w-3 h-3 rounded-full bg-[#26e7a6]"></span></div>
                            <div className="flex items-center gap-2"><span className="w-3 h-3 rounded-full bg-[#f7da05]"></span>300–500</div>
                            <div className="flex items-center gap-2"><span className="w-3 h-3 rounded-full bg-[#61f393]"></span>500+</div>
                          </div>
                        </div>

                      </div>
                    )}
                  </div>

                  {/* Chart 2: Currency Correlation */}
                  <div id="chart" className="w-full">
                    {loading_forgraphs_3rdgraph ? (
                      <div className="h-[400px] flex items-center justify-center bg-white rounded-2xl border border-[#E2E8F0]">
                        <div className="flex flex-col items-center gap-2">
                          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#6366F1]"></div>
                          <p className="text-[#64748B] font-medium text-sm">Loading Chart...</p>
                        </div>
                      </div>
                    )
                      : (
                        <div className="bg-white p-6 rounded-2xl shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] border border-[#E2E8F0]">
                          <div className="flex justify-between items-center mb-6">
                            <h3 className="text-[#334155] font-bold text-lg">Currency Correlation</h3>

                            <div className="px-3 py-1 bg-[#F1F5F9] rounded-lg border border-[#E2E8F0]">
                              <p className="text-xs font-bold text-[#64748B]">Data Count: <span className="text-[#334155]">{DataCount}</span></p>

                            </div>
                          </div>
                          <div style={{ fontFamily: "Helvetica, Arial, sans-serif", fontSize: "14px", color: "black", fontWeight: "Bold" }} className="w-full min-h-[365px]">

                            <ResponsiveContainer width="100%" height={365} >
                              <ComposedChart data={chartData3} barGap={0}
                                barCategoryGap="0%">
                                <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" vertical={false} />
                                <XAxis dataKey="name" tick={{ fill: '#64748B', fontSize: 12 }} axisLine={{ stroke: '#CBD5E1' }} tickLine={false} />
                                <YAxis
                                  yAxisId="left"
                                  tickFormatter={(value) => `${value} %`}
                                  tick={{ fill: '#64748B', fontSize: 12 }}
                                  axisLine={{ stroke: '#CBD5E1' }}
                                  tickLine={false}
                                  label={{
                                    value: "Currency correlation (%)",
                                    angle: -90,
                                    position: "insideLeft",
                                    style: { fill: "#475569", fontWeight: 600, fontSize: 12 },
                                    dy: 70
                                  }}
                                />

                                <YAxis
                                  yAxisId="right"
                                  orientation="right"
                                  tick={{ fill: '#64748B', fontSize: 12 }}
                                  axisLine={{ stroke: '#CBD5E1' }}
                                  tickLine={false}
                                  label={{
                                    value: "Average Movement (%) ",
                                    angle: 90,
                                    position: "insideRight",
                                    style: { fill: "#475569", fontWeight: 600, fontSize: 12 },
                                    dy: 70
                                  }}
                                />
                                <Tooltip
                                  contentStyle={{ borderRadius: '12px', border: 'none', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}
                                />
                                <ReferenceLine
                                  y={0}
                                  yAxisId="left"
                                  stroke="#94A3B8"
                                  strokeDasharray="3 3"
                                />

                                <Bar dataKey="Level0" stackId="Level0" barSize={20} yAxisId="left"
                                  shape={(props) => {
                                    const { x, y, width, height, fill } = props;
                                    const textOffset = 20;
                                    return (
                                      <g>
                                        <rect
                                          x={x + 20} // Shift it manually
                                          y={y}
                                          width={width}
                                          height={height}
                                          fill={fill}
                                        />
                                      </g>
                                    );
                                  }}
                                >
                                  {chartData3.map((entry, index) => (
                                    <Cell key={`cell-level0-${index}`} fill={entry.fillColor} />
                                  ))}
                                </Bar>


                                <Bar dataKey="Level1" stackId="Level1" barSize={20} yAxisId="left"
                                >
                                  {chartData3.map((entry, index) => (
                                    <Cell key={`cell-level1-${index}`} fill={entry.fillColor} />
                                  ))}
                                </Bar>

                                <Line type="monotone" dataKey="MovementAvgPercentage" stroke="#ff0000" strokeWidth={2} dot={{ r: 4 }} yAxisId="right" />
                              </ComposedChart>
                            </ResponsiveContainer>
                            {/* Legend for Chart 2 */}
                            <div className="mt-4 p-3 bg-[#F8FAFC] rounded-xl border border-[#F1F5F9] flex flex-wrap gap-4 text-xs font-medium text-[#64748B] justify-center">
                              <div className="flex items-center gap-2">
                                <img src={lineicon2} alt="Line" className="w-4 h-4 opacity-80" />
                                <span className="text-[#334155] font-bold">Average Movement (%)</span>
                              </div>
                              <div className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 rounded-full bg-[#f57474]"></span>0–65%</div>
                              <div className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 rounded-full bg-[#f7da05]"></span>66-80%</div>
                              <div className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 rounded-full bg-[#61f393]"></span>80%+</div>
                            </div>
                          </div>

                        </div>
                      )}
                  </div>

                  {/* Chart 3: Stacked Bar Analysis */}
                  <div id="chart" className="w-full">
                    {loading_forgraphs_4thgraph ? (
                      <div className="h-[400px] flex items-center justify-center bg-white rounded-2xl border border-[#E2E8F0]">
                        <div className="flex flex-col items-center gap-2">
                          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#6366F1]"></div>
                          <p className="text-[#64748B] font-medium text-sm">Loading Chart...</p>
                        </div>
                      </div>
                    ) : (
                      <div className="bg-white p-6 rounded-2xl shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] border border-[#E2E8F0]">
                        <div className="flex justify-between items-center mb-6">
                          <h3 className="text-[#334155] font-bold text-lg">Stacked Bar Analysis</h3>
                          <div className="px-3 py-1 bg-[#F1F5F9] rounded-lg border border-[#E2E8F0]">
                            <p className="text-xs font-bold text-[#64748B]">Data Count: <span className="text-[#334155]">{DataCount}</span></p>
                          </div>
                        </div>
                        <ResponsiveContainer width="100%" height={365}>
                          <ComposedChart data={chartData}>
                            <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" vertical={false} />
                            <XAxis dataKey="name" tick={{ fill: '#64748B', fontSize: 12 }} axisLine={{ stroke: '#CBD5E1' }} tickLine={false} />
                            <YAxis
                              yAxisId="left"
                              tickFormatter={(value) => `${value} %`}
                              tick={{ fill: '#64748B', fontSize: 12 }}
                              axisLine={{ stroke: '#CBD5E1' }}
                              tickLine={false}
                              label={{
                                value: "% Price movement vs. prior 5 minute range",
                                angle: -90,
                                position: "insideLeft",
                                style: { fill: "#475569", fontWeight: 600, fontSize: 12 },
                                dy: 130
                              }}
                            />
                            <YAxis
                              yAxisId="right"
                              orientation="right"
                              tick={{ fill: '#64748B', fontSize: 12 }}
                              axisLine={{ stroke: '#CBD5E1' }}
                              tickLine={false}
                              label={{
                                value: "Area - Average Movement (%)",
                                angle: 90,
                                position: "insideRight",
                                style: { fill: "#475569", fontWeight: 600, fontSize: 12 },
                                dy: 90
                              }}
                            />
                            <Tooltip contentStyle={{ borderRadius: '12px', border: 'none', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }} />
                            <Legend />
                            {chartData.length > 0 &&
                              Object.keys(chartData[0])
                                .filter(key => /^\d{4}\.\d{2}\.\d{2}$/.test(key))
                                .map((date, index) => (
                                  <Bar
                                    key={date}
                                    dataKey={date}
                                    stackId="stack"
                                    barSize={30}
                                    fill={someColorPalette[index % someColorPalette.length]}
                                    yAxisId="left"
                                  />
                                ))}
                            <Area type="monotone" dataKey="MovementAvgPercentage" stroke="#ff7300" fill="#ff7300" fillOpacity={0.3} yAxisId="right" />
                          </ComposedChart>
                        </ResponsiveContainer>
                      </div>
                    )}
                  </div>
                </div>

                {/* Column 2: Zero Event */}
                <div className="flex flex-col gap-6">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="h-8 w-1 bg-[#F472B6] rounded-full"></div>
                    <h1 className="text-xl font-bold text-[#1E293B] tracking-tight">Zero event</h1>
                  </div>

                  {/* Chart 3: Zero Movement Analysis */}
                  <div id="chart" className="w-full">
                    {loading_forgraphs_1stGraph_flat ? (
                      <div className="h-[400px] flex items-center justify-center bg-white rounded-2xl border border-[#E2E8F0]">
                        <div className="flex flex-col items-center gap-2">
                          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#6366F1]"></div>
                          <p className="text-[#64748B] font-medium text-sm">Loading Chart...</p>
                        </div>
                      </div>
                    ) : (
                      noDataAvailable ?
                        <div className="h-[400px] flex items-center justify-center bg-white rounded-2xl border border-[#E2E8F0]">
                          <div className="flex flex-col items-center gap-2">
                            <p className="text-[#64748B] font-medium text-sm">No Zero Event Data Available</p>
                          </div>
                        </div>
                        :
                        <div className="bg-white p-6 rounded-2xl shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] border border-[#E2E8F0]">
                          <div className="flex justify-between items-center mb-6">
                            <h3 className="text-[#334155] font-bold text-lg">Zero Movement Analysis</h3>

                            <div className="px-3 py-1 bg-[#F1F5F9] rounded-lg border border-[#E2E8F0]">
                              <p className="text-xs font-bold text-[#64748B]">Data Count: <span className="text-[#334155]">{dataCount_flat0}</span></p>

                            </div>
                          </div>
                          <ReactApexChart
                            options={state_1stGraph_flat.options}
                            series={state_1stGraph_flat.series}
                            type="line"
                            height={350}
                          />
                          {/* Legend 3 */}
                          <div className="mt-6 p-4 bg-[#F8FAFC] rounded-xl border border-[#F1F5F9]">
                            <div className="flex flex-wrap gap-y-3 gap-x-6 justify-center items-center text-sm text-[#475569]">
                              <div className="flex items-center gap-2 min-w-[200px]">
                                <img src={baricon} alt="bars" className="w-4 h-4 opacity-70" />
                                <span className="font-bold">Average Movement (%):</span>
                              </div>
                              <div className="flex items-center gap-2"><span className="w-3 h-3 rounded-full bg-[#f57474]"></span>0–299</div>
                              <div className="flex items-center gap-2"><span className="w-3 h-3 rounded-full bg-[#f7da05]"></span>300–499</div>
                              <div className="flex items-center gap-2"><span className="w-3 h-3 rounded-full bg-[#61f393]"></span> 500+</div>
                            </div>
                            <div className="flex flex-wrap gap-y-3 gap-x-6 justify-center items-center text-sm text-[#475569] mt-3 pt-3 border-t border-[#E2E8F0]">
                              <div className="flex items-center gap-2 min-w-[200px]">
                                <img src={lineicon} alt="line" className="w-4 h-4 opacity-70" />
                                <span className="font-bold">Average Movement (points):</span>
                              </div>
                              <div className="opacity-0"><span className="w-3 h-3 rounded-full bg-[#26e7a6]"></span></div>
                              <div className="flex items-center gap-2"><span className="w-3 h-3 rounded-full bg-[#f7da05]"></span>300–500</div>
                              <div className="flex items-center gap-2"><span className="w-3 h-3 rounded-full bg-[#61f393]"></span>500+</div>
                            </div>
                          </div>
                        </div>
                    )}
                  </div>

                  {/* Chart 4: Zero Currency Correlation */}
                  <div id="chart" className="w-full">
                    {loading_forgraphs_3rdgraph_flat0 ? (
                      <div className="h-[400px] flex items-center justify-center bg-white rounded-2xl border border-[#E2E8F0]">
                        <div className="flex flex-col items-center gap-2">
                          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#6366F1]"></div>
                          <p className="text-[#64748B] font-medium text-sm">Loading Chart...</p>
                        </div>
                      </div>
                    )
                      : (
                        noDataAvailable_3rdgraph ?
                          <div className="h-[400px] flex items-center justify-center bg-white rounded-2xl border border-[#E2E8F0]">
                            <div className="flex flex-col items-center gap-2">
                              <p className="text-[#64748B] font-medium text-sm">No Zero Event Data Available</p>
                            </div>
                          </div> :
                          <div className="bg-white p-6 rounded-2xl shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] border border-[#E2E8F0]">
                            <div className="flex justify-between items-center mb-6">
                              <h3 className="text-[#334155] font-bold text-lg">Zero Currency Correlation</h3>

                              <div className="px-3 py-1 bg-[#F1F5F9] rounded-lg border border-[#E2E8F0]">
                                <p className="text-xs font-bold text-[#64748B]">Data Count: <span className="text-[#334155]">{dataCount_flat0}</span></p>

                              </div>
                            </div>
                            <div style={{ fontFamily: "Helvetica, Arial, sans-serif", fontSize: "14px", color: "black", fontWeight: "Bold" }} className="w-full min-h-[365px]">

                              <ResponsiveContainer width="100%" height={365} >
                                <ComposedChart data={chartData3_flat0} barGap={0}
                                  barCategoryGap="0%">
                                  <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" vertical={false} />
                                  <XAxis dataKey="name" tick={{ fill: '#64748B', fontSize: 12 }} axisLine={{ stroke: '#CBD5E1' }} tickLine={false} />
                                  <YAxis
                                    yAxisId="left"
                                    tickFormatter={(value) => `${value} %`}
                                    tick={{ fill: '#64748B', fontSize: 12 }}
                                    axisLine={{ stroke: '#CBD5E1' }}
                                    tickLine={false}
                                    label={{
                                      value: "Currency correlation (%)",
                                      angle: -90,
                                      position: "insideLeft",
                                      style: { fill: "#475569", fontWeight: 600, fontSize: 12 },
                                      dy: 70
                                    }}
                                  />

                                  <YAxis
                                    yAxisId="right"
                                    orientation="right"
                                    tick={{ fill: '#64748B', fontSize: 12 }}
                                    axisLine={{ stroke: '#CBD5E1' }}
                                    tickLine={false}
                                    label={{
                                      value: "Average Movement (%) ",
                                      angle: 90,
                                      position: "insideRight",
                                      style: { fill: "#475569", fontWeight: 600, fontSize: 12 },
                                      dy: 70
                                    }}
                                  />
                                  <Tooltip
                                    contentStyle={{ borderRadius: '12px', border: 'none', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}
                                  />
                                  <ReferenceLine
                                    y={0}
                                    yAxisId="left"
                                    stroke="#94A3B8"
                                    strokeDasharray="3 3"
                                  />

                                  <Bar dataKey="Level0" stackId="Level0" barSize={20} yAxisId="left"
                                    shape={(props) => {
                                      const { x, y, width, height, fill } = props;
                                      const textOffset = 20;
                                      return (
                                        <g>
                                          <rect
                                            x={x + 20} // Shift it manually
                                            y={y}
                                            width={width}
                                            height={height}
                                            fill={fill}
                                          />
                                        </g>
                                      );
                                    }}
                                  >
                                    {chartData3_flat0.map((entry, index) => (
                                      <Cell key={`cell-level0-${index}`} fill={entry.fillColor} />
                                    ))}
                                  </Bar>
                                  <Bar dataKey="Level1" stackId="Level1" barSize={20} yAxisId="left"
                                  >
                                    {chartData3_flat0.map((entry, index) => (
                                      <Cell key={`cell-level1-${index}`} fill={entry.fillColor} />
                                    ))}
                                  </Bar>
                                  <Line type="monotone" dataKey="MovementAvgPercentage" stroke="#ff0000" strokeWidth={2} dot={{ r: 4 }} yAxisId="right" />
                                </ComposedChart>
                              </ResponsiveContainer>
                              {/* Legend for Chart 4 */}
                              <div className="mt-4 p-3 bg-[#F8FAFC] rounded-xl border border-[#F1F5F9] flex flex-wrap gap-4 text-xs font-medium text-[#64748B] justify-center">
                                <div className="flex items-center gap-2">
                                  <img src={lineicon2} alt="Line" className="w-4 h-4 opacity-80" />
                                  <span className="text-[#334155] font-bold">Average Movement (%)</span>
                                </div>
                                <div className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 rounded-full bg-[#f57474]"></span>0–65%</div>
                                <div className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 rounded-full bg-[#f7da05]"></span>66-80%</div>
                                <div className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 rounded-full bg-[#61f393]"></span>80%+</div>
                              </div>
                            </div>
                          </div>
                      )}
                  </div>

                  {/* Chart 5: Flat Event Extra (If Needed) */}
                  <div id="chart" className="w-full">
                    {loading_forgraphs_4thgraph_flat0 ? (
                      <p>loading.... </p>
                    ) : (
                      <>
                        <div style={{ fontFamily: "Helvetica, Arial, sans-serif", fontSize: "14px", color: "black", fontWeight: "Bold" }} className="border rounded-md bg-[#fff] p-5 text-black h-[530px]">
                          <div className="flex justify-end items-center w-full">
                            <div className="flex justify-start items-center m-4 border border-solid border-[#240d3a] w-[124px]">
                              <p className="p-1 text-[13px] font-bold">Data Count : {dataCount_flat0}</p>

                            </div>
                          </div>
                          <ResponsiveContainer width="100%" height={365} >
                            <ComposedChart data={chartData_flat0}>
                              <CartesianGrid strokeDasharray="3 3" />
                              <XAxis dataKey="name" />
                              <YAxis
                                yAxisId="left"
                                tickFormatter={(value) => `${value} %`}
                                label={{
                                  value: "% Price movement vs. prior 5 minute range",
                                  angle: -90,
                                  position: "insideLeft",
                                  style: { fill: "#686868" },
                                  dy: 130
                                }}
                              />

                              <YAxis
                                yAxisId="right"
                                orientation="right"
                                label={{
                                  value: "Area - Average Movement (%) ",
                                  angle: 90,
                                  position: "insideRight",
                                  style: { fill: "#686868" },
                                  dy: 90
                                }}
                              />


                              <Tooltip />
                              <Legend />

                              {chartData_flat0.length > 0 &&
                                Object.keys(chartData_flat0[0])
                                  .filter(key => /^\d{4}\.\d{2}\.\d{2}$/.test(key))
                                  .map((date, index) => (
                                    <Bar
                                      key={date}
                                      dataKey={date}
                                      stackId="stack"
                                      barSize={30}
                                      fill={someColorPalette[index % someColorPalette.length]}
                                      yAxisId="left"
                                    />
                                  ))}

                              <Area type="monotone" dataKey="MovementAvgPercentage" stroke="#ff7300" fill="#ff7300" fillOpacity={0.3} yAxisId="right" />
                            </ComposedChart>
                          </ResponsiveContainer>
                        </div>
                      </>
                    )}
                  </div>

                </div>
              </div>

            </>
        }

      </div >
    </>
  );
};

export default VisualisationPage;
